import { UseQueryExecute, useQuery } from "urql";
import {
  AddUserToCrewMutation,
  AddUserToCrewMutationVariables,
  CrewInformationUb,
  CrewListQueryQuery,
  CrewListQueryQueryVariables,
  CrewsByOrganizationQuery,
  CrewsByOrganizationQueryVariables,
  LeaveCrewMutation,
  LeaveCrewMutationVariables,
  OrganizationCrewUb,
} from "../gql/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

export function useCrewsQuery(): {
  crews: ReadonlyArray<CrewInformationUb> | undefined;
  reexecuteQuery: UseQueryExecute;
} {
  const [result, reexecuteQuery] = useQuery({
    query: crewsQuery,
    // requestPolicy: "cache-and-network"
  });

  return {
    crews: result.data?.crews,
    reexecuteQuery,
  };
}

export function useCrewsByOrganizationQuery(organizationId: string): {
  crewsByOrganization: ReadonlyArray<OrganizationCrewUb> | undefined;
  reexecuteQuery: UseQueryExecute;
} {
  const [result, reexecuteQuery] = useQuery({
    query: crewsByOrganizationQuery,
    variables: { id: organizationId },
    pause: !organizationId,
  });

  return {
    crewsByOrganization: result.data?.crewsByOrganization,
    reexecuteQuery,
  };
}

export const crewsQuery: TypedDocumentNode<
  CrewListQueryQuery,
  CrewListQueryQueryVariables
> = graphql(`
  query crewListQuery {
    crews {
      identifier
      joiningIdentifier
      title
      bucket
    }
  }
`);

export const crewsByOrganizationQuery: TypedDocumentNode<
  CrewsByOrganizationQuery,
  CrewsByOrganizationQueryVariables
> = graphql(`
  query crewsByOrganization($id: ID!) {
    crewsByOrganization(id: $id) {
      identifier
      joiningIdentifier
      title
      organizationId
      playlistCount
      isPrivateCrew
      members
    }
  }
`);

export const leaveCrewMutation: TypedDocumentNode<
  LeaveCrewMutation,
  LeaveCrewMutationVariables
> = graphql(`
  mutation leaveCrew($identifier: String!) {
    leaveCrew(identifier: $identifier)
  }
`);

export const addUserToCrewMutation: TypedDocumentNode<
  AddUserToCrewMutation,
  AddUserToCrewMutationVariables
> = graphql(`
  mutation addUserToCrew($joiningIdentifier: String!) {
    addUserToCrew(joiningIdentifier: $joiningIdentifier) {
      title
    }
  }
`);
